import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card } from '@totalsoft/rocket-ui';
import Divider from '@mui/material/Divider';
import DocumentTemplateSignatureBookmarkListCard from './signatureBookmark/DocumentTemplateSignatureBookmarkListCard';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import DocumentTemplateSignatureBookmarkOptionListCard from './signatureBookmarkOption/DocumentTemplateSignatureBookmarkOptionListCard';
import DocumentTemplateSignatureHeaderCard from './header/DocumentTemplateSignatureHeaderCard';

const DocumentTemplateSignatureCard = ({
  documentTemplate,
  signatureTypes,
  requiredDocTypes,
  onSelectedClick,
  onImplicitClick,
  onHeaderPropertyChanged,
  onSaveDocumentTemplateXSignatures,
  onDocumentTemplateNeedsSigningChanged,
  documentTemplateXSignaturesValidation,
  signatureActors,
  loadingSignatureActors,
  onSaveSignatureBookmarks,
  saveBookmarksDisabled,
  signatureBookmarkValidation,
  onBookmarkPropertyChanged,
  onLookupPropertyChanged,
  onAddNewBookmark,
  onBookmarkDeleted,
  optionSources,
  loadingOptionSources,
  onSaveDocumentTemplateXoptionBookmarks,
  documentTemplateXoptionsBookmarkValidation,
  onAddNewOptionBookmark,
  onOptionBookmarkPropertyChanged,
  onLookupOptionBookmarkPropertyChanged,
  saveDocumentTemplateXoptionsBookmarkDisabled,
  onOptionBookmarkDeleted
}) => {
  const [t] = useTranslation();

  return (
    <Card icon={LibraryAddCheckIcon} iconColor='primary' title={t('DocumentTemplate.Signature')}>
      <>
        <DocumentTemplateSignatureHeaderCard
          documentTemplate={documentTemplate}
          signatureTypes={signatureTypes}
          requiredDocTypes={requiredDocTypes}
          onSelectedClick={onSelectedClick}
          onImplicitClick={onImplicitClick}
          onPropertyChanged={onHeaderPropertyChanged}
          onSave={onSaveDocumentTemplateXSignatures}
          onDocumentTemplateNeedsSigningChanged={onDocumentTemplateNeedsSigningChanged}
          validation={documentTemplateXSignaturesValidation}
        />
        <Divider />

        {documentTemplate?.needsSigning && !loadingSignatureActors && (
          <DocumentTemplateSignatureBookmarkListCard
            documentTemplate={documentTemplate}
            signatureActors={signatureActors}
            onSave={onSaveSignatureBookmarks}
            saveBookmarksDisabled={saveBookmarksDisabled}
            validation={signatureBookmarkValidation}
            onPropertyChanged={onBookmarkPropertyChanged}
            onLookupPropertyChanged={onLookupPropertyChanged}
            onAddNewBookmark={onAddNewBookmark}
            onBookmarkDeleted={onBookmarkDeleted}
          />
        )}
        <Divider />

        {documentTemplate?.needsSigning && !loadingOptionSources && (
          <DocumentTemplateSignatureBookmarkOptionListCard
            documentTemplate={documentTemplate}
            optionSources={optionSources}
            onSave={onSaveDocumentTemplateXoptionBookmarks}
            validation={documentTemplateXoptionsBookmarkValidation}
            onAddNewOptionBookmark={onAddNewOptionBookmark}
            onOptionBookmarkPropertyChanged={onOptionBookmarkPropertyChanged}
            onLookupOptionBookmarkPropertyChanged={onLookupOptionBookmarkPropertyChanged}
            buttonsDisabled={!documentTemplate.documentTemplateXOptionBookmarksChanged || saveDocumentTemplateXoptionsBookmarkDisabled}
            onOptionBookmarkDeleted={onOptionBookmarkDeleted}
          />
        )}
      </>
    </Card>
  );
};

DocumentTemplateSignatureCard.propTypes = {
  documentTemplate: PropTypes.object,
  signatureTypes: PropTypes.array.isRequired,
  requiredDocTypes: PropTypes.array.isRequired,
  onSelectedClick: PropTypes.func,
  onImplicitClick: PropTypes.func,
  onHeaderPropertyChanged: PropTypes.func,
  onSaveDocumentTemplateXSignatures: PropTypes.func,
  onDocumentTemplateNeedsSigningChanged: PropTypes.func,
  documentTemplateXSignaturesValidation: PropTypes.object.isRequired,
  signatureActors: PropTypes.array.isRequired,
  loadingSignatureActors: PropTypes.bool,
  onSaveSignatureBookmarks: PropTypes.func,
  saveBookmarksDisabled: PropTypes.bool,
  signatureBookmarkValidation: PropTypes.object.isRequired,
  onBookmarkPropertyChanged: PropTypes.func,
  onLookupPropertyChanged: PropTypes.func,
  onAddNewBookmark: PropTypes.func,
  onBookmarkDeleted: PropTypes.func,
  optionSources: PropTypes.array.isRequired,
  loadingOptionSources: PropTypes.bool,
  onSaveDocumentTemplateXoptionBookmarks: PropTypes.func,
  documentTemplateXoptionsBookmarkValidation: PropTypes.object.isRequired,
  onAddNewOptionBookmark: PropTypes.func,
  onOptionBookmarkPropertyChanged: PropTypes.func,
  onLookupOptionBookmarkPropertyChanged: PropTypes.func,
  saveDocumentTemplateXoptionsBookmarkDisabled: PropTypes.bool,
  onOptionBookmarkDeleted: PropTypes.func.isRequired
};

export default DocumentTemplateSignatureCard;
